<template>
  <v-card class="my-2 px-2">
    <v-row 
      v-if="$vuetify.breakpoint.smAndDown"
      no-gutters
      class="d-flex flex-nowrap justify-space-between"
    >
      <div class="pr-3 py-1 font-weight-bold text-right text-no-wrap">
        {{ minutesToDisplay(dbTimeToMinutes(reservation.time)[0]) }}
      </div>
      <div class="d-flex justify-end text-truncate">
        <div class="font-weight-bold text-no-wrap text-truncate align-self-center">
          {{ server.lastName }}
        </div>
        <server-initial-icon 
          :server="server"
          class="pl-1"
        /> 
      </div>
    </v-row>
    <v-divider 
      v-if="$vuetify.breakpoint.smAndDown"
      style="width: 95%; border-color: grey; margin: auto;"
    />
    <v-row no-gutters>
      <v-col 
        align-self="center"
        cols="4"
        lg="2"
        class="px-1 d-flex justify-center"
      >
        <table-names-card 
          :table-names="tableNames || 'UNDEF'"
          right
          tooltip-color="primary"
        />
      </v-col>
      <v-col 
        v-if="$vuetify.breakpoint.lgAndUp"
        align-self="center"
        cols="2"
        class="text-center font-weight-bold"
      >
        {{ reservation.covers }}
      </v-col>
      <v-col 
        align-self="center"
        cols="8"
        md="4"
        :class="{'text-right': $vuetify.breakpoint.smAndDown}"
        class="font-weight-bold text-no-wrap text-truncate"
      >
        {{ reserveeName || 'UNDEF' }}
      </v-col>
      <v-spacer />
      <v-col 
        v-if="$vuetify.breakpoint.mdAndUp"
        cols="4"
      >
        <div class="d-flex justify-end">
          <div class="font-weight-bold text-no-wrap text-truncate align-self-center">
            {{ server.name }}
          </div>
          <server-initial-icon 
            :server="server"
            class="pl-2"
          />
        </div>
        <div class="font-weight-bold text-right">
          <span v-if="reservation.time">
            {{ minutesToDisplay(dbTimeToMinutes(reservation.time)[0]) }}
          </span>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import floorPlanHelpers from '../../mixins/floorPlanHelpers'
import floorPlanTimeHelpers from '../../mixins/floorPlanTimeHelpers'
export default {
  name: 'AssignmentCard',
  mixins: [floorPlanTimeHelpers, floorPlanHelpers], 
  props: {
    server: {
      type: Object,
      default () {return {}}
    },
    reservation: {
      type: Object,
      default () {return {}}
    }
  },
  data () {
    return {showTooltip: false}
  },
  computed: {
    tableNames () {
      let tables = this.reservation.tableAssignments?.map(t => t.locationTableName) ?? []
      return tables.join(', ')
    },
    reservationDetails () {
      return this.reservation.details?.[0] ?? {}
    },
    reserveeName () {
      return this.reservationDetails.name
    }
  }
}
</script>